import { getNetwork } from '../src/getNetwork';

export const network = getNetwork();
